/**
 * Which face a request goes through: the staff API with the instructor token, or the
 * portal API for one target member (self or ward) with the portal token.
 */
export type MessagesChannel = { kind: "staff" } | { kind: "portal"; memberId: string };

export const STAFF_CHANNEL: MessagesChannel = { kind: "staff" };

/** A stable key for per-channel state (threads, unread count). */
export const channelKey = (channel: MessagesChannel): string =>
  channel.kind === "staff" ? "staff" : `portal:${channel.memberId}`;
